'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageBusEventError = require('../errors/message-bus-event-error');

var _messageBusEventError2 = _interopRequireDefault(_messageBusEventError);

var _httpRequest = require('../http/http-request');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _requestMethod = require('../http/request-method');

var _requestMethod2 = _interopRequireDefault(_requestMethod);

var _eventValidator = require('../validator/event-validator');

var _eventValidator2 = _interopRequireDefault(_eventValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Client for sending events to Message Bus Events endpoint.
 */
var MessageBusEventClient = function () {
    /**
     * @param {String} url - Endpoint URL for Message Bus Events.
     * @throws {MessageBusEventError} if url is not of type string.
     */
    function MessageBusEventClient(url) {
        _classCallCheck(this, MessageBusEventClient);

        if (typeof url !== 'string') {
            throw new _messageBusEventError2.default('Cannot instantiate MessageBusEventClient without a url');
        }
        this.url = url;
    }

    /**
     * Sends an event to the Message Bus as an HTTP request.
     * @param {Object} event - Event Object. Should not be null/undefined and must contain mandatory properties.
     * @throws {MessageBusEventError} if the event fails validation.
     * @returns Promise containing result of the HTTP request.
     */


    _createClass(MessageBusEventClient, [{
        key: 'sendEvent',
        value: function sendEvent(event) {
            (0, _eventValidator2.default)(event);
            var httpRequest = new _httpRequest2.default(this.url);
            httpRequest.setMethod(_requestMethod2.default.POST);
            var header = {
                'Content-Type': 'application/json; charset=utf-8'
            };
            httpRequest.setHeaders(header);
            httpRequest.setBody([event]);
            return httpRequest.request();
        }
    }]);

    return MessageBusEventClient;
}();

exports.default = MessageBusEventClient;